<div class="py-[30px]">
  <div>
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "booking-site_detail-widget_enable" | translate }}
            <!-- Enable this widget -->
          </div>
          <div class="v4-layout-form-desc">
            {{ "booking-site_detail-widget_enable_desc" | translate }}
            <!-- Only widgets that are "enabled" can accept bookings. -->
          </div>
        </div>
      </div>
      <div>
        <nz-switch [(ngModel)]="enabled" (ngModelChange)="onStatusChange($event)"></nz-switch>
      </div>
    </div>
  </div>

  @if (enabled) {
    <div class="mt-12">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "booking-site_detail-widget_my_widget" | translate }}
            <!-- My booking widget -->
          </div>
          <div class="v4-layout-form-desc">
            {{ "booking-site_detail-widget_my_widget_desc" | translate }}
            <!-- Copy the code below and paste it into your own website. -->
          </div>

          <div>
            <textarea class="w-full" nz-input rows="10" readonly [ngModel]="code"></textarea>
          </div>
        </div>
      </div>
      <div class="mt-[20px]">
        <button nz-button nzType="primary" nzSize="large" hostClipboard [clipboardData]="code">
          {{ "word.copy_to_clipboard" | translate }}
          <!-- Copy to clipboard -->
        </button>
        <button class="ml-[12px]" nz-button nzSize="large" (click)="previewVisible = true">
          {{ "word.preview" | translate }}
          <!-- Preview -->
        </button>
      </div>
    </div>
  }
</div>

<nz-modal nzWidth="450" [(nzVisible)]="previewVisible" [nzFooter]="null" (nzOnCancel)="previewVisible = false">
  <div *nzModalContent>
    <div [innerHTML]="code | html"></div>
  </div>
</nz-modal>
